import React, { useEffect } from "react";
import PurchaseList from "../../components/admin/PurchaseList";


const PurchaseListPage = () => {

    useEffect(() => {
        document.body.id = "purchaselist-002";
      }, []);

  return (
    <div>
    <PurchaseList />
    </div>
  );
};

export default PurchaseListPage; 
